import { HTMLMotionProps, motion } from "framer-motion";

type Variant = "primary" | "secondary" | "ghost";
type Size = "md" | "lg";

const base =
  "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-[background-color,box-shadow,color] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:ring-offset-2 focus-visible:ring-offset-paper disabled:opacity-60 disabled:pointer-events-none";

const VARIANTS: Record<Variant, string> = {
  primary: "bg-primary-500 hover:bg-primary-600 text-white shadow-warm hover:shadow-glow",
  secondary: "bg-cream-200 hover:bg-cream text-ink ring-1 ring-primary-200/70",
  ghost: "text-ink/70 hover:text-ink hover:bg-ink/5",
};

const SIZES: Record<Size, string> = {
  md: "px-5 py-2.5 text-sm",
  lg: "px-7 py-3.5 text-base",
};

type Props = HTMLMotionProps<"button"> & {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
};

/** Brand button: pill shape, warm shadow, tactile tap feedback. */
const Button: React.FC<Props> = ({
  variant = "primary",
  size = "md",
  fullWidth = false,
  className = "",
  ...rest
}) => (
  <motion.button
    whileTap={{ scale: 0.97 }}
    transition={{ type: "spring", stiffness: 400, damping: 25 }}
    className={`${base} ${VARIANTS[variant]} ${SIZES[size]} ${fullWidth ? "w-full" : ""} ${className}`}
    {...rest}
  />
);

export default Button;
